import { categories } from "@/mocks/comicData";

const toneClass: Record<string, { icon: string; border: string; count: string }> = {
  primary: {
    icon: "bg-primary-100 text-primary-700",
    border: "hover:border-primary-300",
    count: "text-primary-700",
  },
  accent: {
    icon: "bg-accent-100 text-accent-700",
    border: "hover:border-accent-300",
    count: "text-accent-700",
  },
  secondary: {
    icon: "bg-secondary-100 text-secondary-700",
    border: "hover:border-secondary-300",
    count: "text-secondary-700",
  },
};

export default function Categories() {
  return (
    <section id="category" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-grid-line" />
              漫画分类
            </span>
            <h2 className="font-heading mt-4 text-3xl text-foreground-950 md:text-4xl">
              热门品类一网打尽
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
            从热血燃漫到轻松搞笑，总有一款适合你。进入入口后可按分类浏览，快速找到想追的作品。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => {
            const t = toneClass[cat.tone];
            return (
              <a
                key={cat.name}
                href="#entrance"
                className={`group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-all hover:bg-background-50 ${t.border}`}
              >
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${t.icon}`}
                >
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="min-w-0">
                  <span className="flex items-center gap-2">
                    <span className="text-base font-bold text-foreground-950">{cat.name}</span>
                    <span className={`text-xs font-bold ${t.count}`}>{cat.count}</span>
                  </span>
                  <span className="mt-1 block truncate text-xs text-foreground-600">
                    {cat.desc}
                  </span>
                </span>
                <i className="ri-arrow-right-s-line ml-auto shrink-0 text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}